import { render } from "./lngbbd.vue?vue&type=template&id=fe3a655e&scoped=true&ts=true"
import script from "./lngbbd.vue?vue&type=script&lang=ts"
export * from "./lngbbd.vue?vue&type=script&lang=ts"

import "./lngbbd.vue?vue&type=style&index=0&id=fe3a655e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3a655e"]])

export default __exports__